import { AffiliateOfferZone } from "@lib/shared/config";
import { getAffiliateListId } from "@lib/shared/cookies";
import { ListingItem } from "@lib/shared/types";
import { CookieValueTypes } from "cookies-next/lib/types";
import React, { useEffect, useState } from "react";
import { callEvent } from "src/api";
import { useDomainContext } from "@hooks/useDomainContext";
import MobileIcon from "./mobileIcon";
import styles from "./style.module.scss";
import { getText } from "../offerVertical";
export default function AffiliateOfferUrl({
    className,
    children,
    customHref,
    offer,
    target,
    style,
    zone,
    template = "default",
}: {
    className?: string;
    children?: React.ReactNode;
    customHref?: string;
    offer: ListingItem | undefined | null;
    target?: React.HTMLAttributeAnchorTarget | undefined;
    style?: React.CSSProperties | undefined;
    zone: AffiliateOfferZone;
    template?: "default" | "thankYou";
}) {
    const [listId, setListId] = useState<CookieValueTypes | null>(null);
    const { category, locale } = useDomainContext();

    const clickToCallLabel = getText(
        category?.config?.clickToCallLabel,
        locale,
    );

    useEffect(() => {
        setListId(getAffiliateListId());
    }, [getAffiliateListId]);

    const queryParams = [];

    if (listId) {
        queryParams.push(`id=${listId as string}`);
    }

    if (offer?.category?.id) {
        queryParams.push(`categoryId=${offer.category.id.toString()}`);
    }

    if (zone) {
        queryParams.push(`zone=${zone}`);
    }
    let innerLinkContent = children;
    if (customHref) {
        if (template === "default") {
            innerLinkContent = <>{children}</>;
        } else {
            innerLinkContent = (
                <>
                    <span className={styles["clickToCallWrapper"]}>
                        <span className={styles["svgWrapper"]}>
                            <MobileIcon />
                        </span>
                        <span className={styles["textWrapper"]}>
                            <span className={styles["clickToCall"]}>
                                {clickToCallLabel || "Click to Call"}
                            </span>
                            <span className={styles["phoneNumberClick"]}>
                                {children}
                            </span>
                        </span>
                    </span>
                </>
            );
        }
    }

    return (
        <a
            style={style}
            target={target}
            className={className ?? ""}
            rel="noreferrer"
            href={
                customHref ??
                `/offer/${offer?.slug ?? ""}?${queryParams.join("&")}`
            }
            onClick={() => {
                if (customHref) {
                    void callEvent({
                        event: "Call",
                        phoneNumber: customHref?.split("tel:")[1] ?? "",
                    });
                }
            }}
        >
            {innerLinkContent}
        </a>
    );
}
